import { SnackbarComponent } from "@/components";
import { useCallback, useEffect, useMemo } from "react";
import { errorValidator, IMAGES } from "../constants";

import { useRef } from "react";
import { useDispatch } from "react-redux";
import { setModalAttributes } from "../redux/slice/ModalSlice";
import { useRouter } from "next/navigation";

const useErrorHandling = (error) => {
  const isError = useMemo(() => error, [error]);

  const dispatch = useDispatch();
  const router = useRouter();

  const lastErrorRef = useRef();

  const handleLogout = useCallback(() => {
    router.replace("/logout");
  }, []);

  const handleError = useCallback(() => {
    const errorType = isError?.data?.detail?.actionType;
    const errorDetail = isError?.data?.detail;
    const errorMessage = isError?.data?.message;
    const errorDetailMessage =
      typeof errorDetail === "string" ? errorDetail : errorDetail?.message;

    const errorMessageToShow = errorMessage || errorDetailMessage;

    if (!isError) return;
    if (lastErrorRef.current === isError) return;
    lastErrorRef.current = isError;

    if (
      (isError?.name === "TypeError" &&
        isError?.message?.includes("NetworkError")) ||
      isError.status === "FETCH_ERROR"
    ) {
      SnackbarComponent({
        error: true,
        errorMessage:
          "Network error. Please check your connection and try again.",
      });
      return;
    }
    const status = isError?.status;
    if (status === 401) {
      SnackbarComponent({
        error: isError,
        errorMessage: "Your session has expired. Please login again",
      });
      dispatch(
        setModalAttributes({
          open: true,
          message:
            errorMessageToShow ||
            `Just few quick steps left and your loan could be ready for disbursal
            in minutes. Don’t miss out—come back and finish in no time!`,
          type: "SESSION_EXPIRED",
        }),
      );
    } else if (status === 500) {
      SnackbarComponent({
        error: isError,
        errorMessage:
          errorMessageToShow || "Something went wrong. Please try again later.",
        preventDuplicate: true,
      });
    } else if (status > 500) {
      dispatch(
        setModalAttributes({
          open: true,
          message:
            errorMessageToShow ||
            `We’re working on resolving the issue and will be back shortly. You
            can check back soon or explore other sections in the app meanwhile.`,
          type: "TEMPORARY_SERVER_ERROR",
        }),
      );
    } else if (errorType && status >= 400 && status < 500) {
      dispatch(
        setModalAttributes({
          open: true,
          message:
            errorMessageToShow || `There was an issue with your request.`,
          type: isError?.data?.detail?.actionType || "",
          // image: IMAGES.fail,
        }),
      );
      // SnackbarComponent({
      //   error: isError,
      //   errorMessage:
      //     errorValidator(isError) || "Request error. Please check your input.",
      // });
    }
  }, [isError, handleLogout]);

  useEffect(() => {
    handleError();
  }, [isError]);
};

export default useErrorHandling;
